import useGetSearchColumns from '@/hooks/useGetSearchColumns';
import { useAppSelector } from '@/redux/hooks';
import { getSearchedAndPromotedItems } from '@/redux/modules/search/aggregateResults/searchAggregate.selectors';
import { getSimilarItemsGroupsItemIds } from '@/redux/modules/similarItemsGroups';

export const useSimilarActiveItems = () => {
    const columns = useGetSearchColumns({ isOnSearchPage: true });

    const searchPageItemIds = useAppSelector((state) => getSearchedAndPromotedItems(state, columns));

    const firstItemId = searchPageItemIds[0];

    const similarActiveItemIds = useAppSelector((state) =>
        firstItemId ? getSimilarItemsGroupsItemIds(state, firstItemId) : []
    );

    return { firstItemId, similarActiveItemIds };
};
